export default __webpack_public_path__ + "static/media/background_pope_profile.7edaf311.svg";